import { Component, OnInit, AfterViewInit, ViewChild, AfterViewChecked } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { NavigationService, Subscription } from '../core/navigation/navigation.service';
import { HierarcicalMenuComponent } from './hierarcical-menu.component';
import { SubMenuService, SubMenu } from '../core/menu/sub-menu.service';
import { AuthenticationService } from '../_services/authentication/authentication.service';

@Component({
    template: require('./sub-shell.component.html')
})
export class SubShellComponent implements OnInit, AfterViewInit {
 
    private navigationSubscripton: Subscription;
    private subMenuSubscripton: Subscription;

	@ViewChild('submenu') submenu: HierarcicalMenuComponent;

	constructor(
		public auth: AuthenticationService,
        private readonly navigationService: NavigationService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly subMenuService: SubMenuService) { }

    ngOnInit(): void {

        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => {
                let route = this.activatedRoute;
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter((route: any) =>  route.outlet === 'primary')
            .mergeMap((route: any) => route.data)
            .subscribe((event) => {
                //set page title?
            });


        this.navigationSubscripton = this.navigationService.onNavigated.subscribe(route => {
			this.setActiveMenuItem();
	        setTimeout(() => this.submenu.ensureCurrentLeafVisible(), 0);
        });
	

        this.menuItems = MENU;
        this.setActiveMenuItem();
        
	}

	ngAfterViewInit() {
		this.subMenuSubscripton = this.subMenuService.onSubMenuChanged.subscribe(menu => {
			setTimeout(() => this.submenu.ensureCurrentLeafVisible(), 0);
			this.toggleSubMenu(!!menu);
		});
	}

    ngOnDestroy() {
        this.navigationSubscripton.unsubscribe();
        this.subMenuSubscripton.unsubscribe();
    }

	navigate(path: string) {
        this.router.navigateByUrl(path.replace("{{id}}", this.storeId.toString()));
    }

    toggleSubMenu(show: boolean = null) {
        if (this.subMenu) {
            if (show != null) {
                this.subMenu.isVisible = show;
            } else {
                this.subMenu.isVisible = !this.subMenu.isVisible;
            }
        }
        const items = document.getElementsByClassName("page-right-col");
        for (let i = 0; i < items.length; i++) {
            if (!this.subMenu || !this.subMenu.isVisible) {
                items[i].className += " collapsed";
            } else {
                items[i].className = items[i].className.replace(/(?:^|\s)collapsed(?!\S)/g, '');
            }
        }
	}


	setPremisesInformation(popularName: string, storeCode: string, storeId: number) {
		this.storeCode = storeCode;
		this.popularName = popularName;
		this.storeId = storeId;
    }

    private setActiveMenuItem() {
        if (this.menuItems && this.activatedRoute.snapshot.data['routeId']) {
            this.activeMenuItem = this.menuItems.find(x => x.routeId == this.activatedRoute.snapshot.data['routeId']);
        }
    }

	public projectCode: string;
	public storeCode: string;
	public storeId: number;
	public popularName: string;

	public title1: string = null;
	public title2: string = null;
	public title3: string = null;

	public showStoreNavtabs: boolean = true;

	menuItems: MenuItem[];
    activeMenuItem: MenuItem;
	get subMenu() {
		return this.subMenuService.menu;
	}
}

export const MENU: MenuItem[] = [
    {
        name: 'Store',
        color: 'red',
        routeId: 'store',
        path: 'store/{{id}}'
    },
    {
        name: 'Financials',
        color: 'turquoise',
        routeId: 'financials',
        path: ''
    },
    {
        name: 'Contracts',
        color: 'green',
        routeId: 'contract',
        path: 'store/{{id}}/contract'
    },
    {
        name: 'Facilities',
        color: 'emerald',
        routeId: 'facilities',
        path: 'store/{{id}}/facilities'
    },
    {
        name: 'Projects',
        color: 'orange',
        routeId: 'project',
        path: 'store/{{id}}/project'
    },
    {
        name: 'Files',
        color: 'yellow',
        routeId: 'file',
        path: 'store/{{id}}/file'
    }
];

export class MenuItem {
    name: string;
    color: string;
    routeId: string;
    path: string;
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/sub-shell.component.ts